import React from 'react';
import { useTranslate } from '../../mixins/translate/translate';

export function UnitOfMeasurement(props: { value?: undefined | string | null }) {
    const translate = useTranslate();

    if (!props.value) {
        return null;
    }
    switch (props.value) {
        case 'm':
            return <span>m</span>;
        case 'm2':
            return (
                <span>
                    m<sup>2</sup>
                </span>
            );
        case 'm3':
            return (
                <span>
                    m<sup>3</sup>
                </span>
            );
        case 'pcs':
            return <>{translate('common.pcs')}</>;
        default:
            return null;
    }
}
